import React, { useState, useEffect } from 'react';
import './Header.css';

const Header = ({ sector, onOpenModal }) => {
  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);
  const [currentPhraseIndex2, setCurrentPhraseIndex2] = useState(0);
  
  const rotatingPhrases = [
    "À partir de 500€",
    "Déployer en 4 jours",
    "+10 clients",
    "Intégrations solides",
    "ROI rapide",
    "Développement IA"
  ];

  const rotatingPhrases2 = [
    "Support 7j/7",
    "Code personnalisé",
    "API sécurisées",
    "Scalable",
    "Documentation complète",
    "Tests inclus"
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentPhraseIndex((prevIndex) => (prevIndex + 1) % rotatingPhrases.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval2 = setInterval(() => {
      setCurrentPhraseIndex2((prevIndex) => (prevIndex + 1) % rotatingPhrases2.length);
    }, 3500);

    return () => clearInterval(interval2);
  }, []);

  const sectorConfig = {
    immobilier: {
      baseline: (
        <>
          Nous développons des <br /><span className="highlight">solutions d'IA </span>
          dédiées au <br />secteur<span className="highlight">&nbsp;immobilier</span>
        </>
      ),
      visualType: 'building'
    },
    logiciel_IA: {
      baseline: (
        <>
          Votre <span className="highlight">logiciel IA </span>
          <br />sur mesure à <span className="highlight">petit budget</span>
        </>
      ),
      visualType: 'neural'
    },
    audit: {
      baseline: (
        <>
          <span className="highlight">Audit </span> de vos systèmes et
          <br />développement de <span className="highlight">solutions IA</span> sur mesure
        </>
      ),
      visualType: 'neural'
    },
    default: {
      baseline: (
        <>
          Votre <span className="highlight">freelance </span>
          pour vos<span className="highlight"> projet IA</span>
        </>
      ),
      visualType: 'neural'
    }
  };

  const currentConfig = sectorConfig[sector] || sectorConfig.default;
  const isNeuralNetwork = currentConfig.visualType === 'neural';

  const scrollToCalendar = () => {
    const calendar = document.getElementById('calendar');
    if (calendar) {
      calendar.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToProjects = () => {
    const projectsSection = document.getElementById('projets');
    if (projectsSection) {
      projectsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="header-right">
          <img src="/photo/equipe/image_moi_v2.png" alt="Portrait" className="header-photo" />
        </div>
        <div className="header-left">
          <div className="header-content">
            <h2 className="baseline">
              {currentConfig.baseline}
            </h2>
            <p className="header-description">
              Je vous aide à concevoir votre projet IA, que ce soit la création d'agent, de chatbot, d'application web ou logiciel ou l'automatisation de workflow.
            </p>
            <div className="cta-container">
              <button className="cta-button" onClick={onOpenModal}>
                <span className="button-text">
                  <span className="text-default">Consultation gratuite</span>
                  <span className="text-hover">On est partis ?</span>
                </span>
              </button>
              <div className="rotating-phrases-wrapper">
                <div className="rotating-phrase-container">
                  <span className="checkmark">✓</span>
                  <span className="rotating-phrase" key={currentPhraseIndex}>
                    {rotatingPhrases[currentPhraseIndex]}
                  </span>
                </div>
                <div className="rotating-phrase-container">
                  <span className="checkmark">✓</span>
                  <span className="rotating-phrase" key={currentPhraseIndex2}>
                    {rotatingPhrases2[currentPhraseIndex2]}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="partners-logos-section">
          <p className="partners-title">Ils me font confiance :</p>
          <div className="partners-logos">
            <img src="/photo/logo_partenaire/capdiag_logo_sans_fond.png" alt="Capdiag" className="partners-logo" />
            <img src="/photo/logo_partenaire/controle_logo_sans_fond.png" alt="Controle Ton Bulletin" className="partners-logo" />
            <img src="/photo/logo_partenaire/execo_logo_sans_fond.png" alt="Execo" className="partners-logo" />
            <img src="/photo/logo_partenaire/logo_laurent_sans_fondd.png" alt="Laurent" className="partners-logo" />
            <img src="/photo/logo_partenaire/monnaie_logo_sans_fond.png" alt="Monnaie" className="partners-logo" />
            <img src="/photo/logo_partenaire/perano_logo_sans_fond.png" alt="Perano" className="partners-logo" />
          </div>
        </div>
      </div>
    </header>
  );
};
 
export default Header;
